import { HasuraAuthClient as f } from "@nhost/hasura-auth-js";
export * from "@nhost/hasura-auth-js";
import { HasuraStorageClient as g } from "@nhost/hasura-storage-js";
export * from "@nhost/hasura-storage-js";
import w from "isomorphic-unfetch";
import { NhostGraphqlClient as T } from "@nhost/graphql-js";
const b = /^((?<protocol>http[s]?):\/\/)?(?<host>localhost)(:(?<port>(\d+|__\w+__)))?$/;
function d(t, e) {
  const { backendUrl: s, subdomain: r, region: a } = t;
  if (s)
    return `${s}/v1/${e}`;
  if (!r)
    throw new Error("Either `backendUrl` or `subdomain` must be set.");
  const c = r.match(b);
  if (c != null && c.groups) {
    const { protocol: i = "http", host: n, port: o = 1337 } = c.groups, u = U(e);
    return u || `${i}://${n}:${o}/v1/${e}`;
  }
  if (!a)
    throw new Error('`region` must be set when using a `subdomain` other than "localhost".');
  return `https://${r}.${e}.${a}.nhost.run/v1`;
}
function k() {
  return typeof window < "u";
}
function p() {
  return typeof process < "u" && process.env;
}
function U(t) {
  return k() || !p() ? null : process.env[`NHOST_${t.toUpperCase()}_URL`];
}
function m(t, e) {
  const r = e.startsWith("/") ? e : `/${e}`;
  return t + r;
}
function A(t) {
  const e = "subdomain" in t || "backendUrl" in t ? d(t, "auth") : t.authUrl;
  if (!e)
    throw new Error("Please provide `subdomain` or `authUrl`.");
  return new f({ url: e, ...t });
}
function S(t) {
  const e = "subdomain" in t || "backendUrl" in t ? d(t, "functions") : t.functionsUrl;
  if (!e)
    throw new Error("Please provide `subdomain` or `functionsUrl`.");
  return new C({ url: e, ...t });
}
class C {
  constructor(e) {
    const { url: s, adminSecret: r } = e;
    this.url = s, this.accessToken = null, this.adminSecret = r;
  }
  async call(e, s, r) {
    var i;
    const a = {
      "Content-Type": "application/json",
      ...this.generateAccessTokenHeaders(),
      ...r == null ? void 0 : r.headers
    }, c = m(this.url, e);
    try {
      const n = await w(c, {
        body: s ? JSON.stringify(s) : null,
        headers: a,
        method: "POST"
      });
      if (!n.ok)
        throw new Error(n.statusText);
      let o;
      return (i = n.headers.get("content-type")) != null && i.includes("application/json") ? o = await n.json() : o = await n.text(), {
        res: { data: o, status: n.status, statusText: n.statusText },
        error: null
      };
    } catch (n) {
      const o = n;
      return {
        res: null,
        error: {
          message: o.message,
          status: o.name === "AbortError" ? 0 : 500,
          error: o.name === "AbortError" ? "abort-error" : "unknown"
        }
      };
    }
  }
  setAccessToken(e) {
    if (!e) {
      this.accessToken = null;
      return;
    }
    this.accessToken = e;
  }
  generateAccessTokenHeaders() {
    return this.adminSecret ? {
      "x-hasura-admin-secret": this.adminSecret
    } : this.accessToken ? {
      Authorization: `Bearer ${this.accessToken}`
    } : {};
  }
}
function E(t) {
  const e = "subdomain" in t || "backendUrl" in t ? d(t, "graphql") : t.graphqlUrl;
  if (!e)
    throw new Error("Please provide `subdomain` or `graphqlUrl`.");
  return new T({ url: e, ...t });
}
function v(t) {
  const e = "subdomain" in t || "backendUrl" in t ? d(t, "storage") : t.storageUrl;
  if (!e)
    throw new Error("Please provide `subdomain` or `storageUrl`.");
  return new g({ url: e, ...t });
}
const N = (t) => new $(t);
class $ {
  constructor({
    refreshIntervalTime: e,
    clientStorage: s,
    clientStorageType: r,
    autoRefreshToken: a,
    autoSignIn: c,
    adminSecret: i,
    devTools: n,
    start: o = !0,
    ...u
  }) {
    this.auth = A({
      refreshIntervalTime: e,
      clientStorage: s,
      clientStorageType: r,
      autoRefreshToken: a,
      autoSignIn: c,
      start: o,
      ...u
    }), this.storage = v({ adminSecret: i, ...u }), this.functions = S({ adminSecret: i, ...u }), this.graphql = E({ adminSecret: i, ...u }), this.auth.onAuthStateChanged((l, h) => {
      l === "SIGNED_OUT" && (this.storage.setAccessToken(void 0), this.functions.setAccessToken(void 0), this.graphql.setAccessToken(void 0));
    }), this.auth.onTokenChanged((l) => {
      const h = l == null ? void 0 : l.accessToken;
      this.storage.setAccessToken(h), this.functions.setAccessToken(h), this.graphql.setAccessToken(h);
    }), this._adminSecret = i, this.devTools = n;
  }
  get adminSecret() {
    return this._adminSecret;
  }
  set adminSecret(e) {
    this._adminSecret = e, this.storage.setAdminSecret(e);
  }
}
export {
  $ as NhostClient,
  C as NhostFunctionsClient,
  A as createAuthClient,
  S as createFunctionsClient,
  E as createGraphqlClient,
  N as createNhostClient,
  v as createStorageClient
};
//# sourceMappingURL=index.esm.js.map
